export default {"src":"/_next/static/media/discord-black.25330b8c.svg","height":16,"width":16};